module.exports = __webpack_public_path__ + "img/tickets.a9b1f6c4.svg";